"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var patterns_1 = __importDefault(require("./components/patterns"));
var size_guide_1 = __importDefault(require("./components/size-guide"));
exports.default = (function (_a) {
    var patterns = _a.patterns, title = _a.title, subtitle = _a.subtitle, sizes = _a.sizes, weightSliderTitle = _a.weightSliderTitle, minWeight = _a.minWeight, maxWeight = _a.maxWeight, sizeChartCTA = _a.sizeChartCTA, sizeChartUrl = _a.sizeChartUrl, sizeChartUrlMobile = _a.sizeChartUrlMobile, daytimeURL = _a.daytimeURL;
    if (!patterns) {
        return null;
    }
    var sizeGuideProps = {
        sizes: sizes ? sizes : [],
        weightSliderTitle: weightSliderTitle || '',
        sizeChartCTA: sizeChartCTA || '',
        sizeChartUrl: sizeChartUrl || '',
        sizeChartUrlMobile: sizeChartUrlMobile || sizeChartUrl || '',
        minWeight: minWeight || 0,
        maxWeight: maxWeight || 0,
        daytimeURL: daytimeURL || '',
    };
    return (React.createElement("div", null,
        React.createElement(patterns_1.default, { patterns: patterns, title: title, subtitle: subtitle }),
        React.createElement(size_guide_1.default, __assign({}, sizeGuideProps))));
});
